export default /* glsl */`
varying vec2 vUv;
uniform mat3 uvTransform;

void main() {
  vUv = (uvTransform * vec3(uv, 1)).xy;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`;